import React from 'react';
import postData from './postData';
import formatter from './formatter';
import { useState, useEffect } from 'react';

const useCalendar = (appointment,
    setAppointment,
    selectedEvent,
    setSelectedEvent,
    resourceUrl,
    eventUrl,
    newAppointment,
    setAlert,
    confirm,
    setSaving
) => {

    const [events, setEvents] = useState([]);
    const [resources, setResources] = useState([]);
    const [dates, setDates] = useState({});

    //get resources on first load
    useEffect(() => {
        postData(resourceUrl, null, (data) => setResources(data.items), null, true);
    },
        [resourceUrl]);

    const setEventsWithClass = (data) => {
        for (let i = 0; i < data.length; i++) {
            //if no classNames, create new array
            data[i].classNames = data[i].classNames || [];
            if (selectedEvent) {
                if (data[i].id === parseInt(selectedEvent.id) &&
                    data[i].appointmentType === selectedEvent.appointmentType) {
                    data[i].classNames.push('event-selected');
                }
                //set all events to not editable if one is currently selected
                data[i].editable = false;
            }
            if (data[i].editable) {
                if (!data[i].classNames.includes('cursor-pointer')) {
                    data[i].classNames.push('cursor-pointer');
                }
            } else {
                data[i].classNames = data[i].classNames.filter(item => item !== 'cursor-pointer');
            }
        }
        if (selectedEvent) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].id === parseInt(selectedEvent.id) &&
                    data[i].appointmentType === selectedEvent.appointmentType) {
                    //if no classNames, create new array
                    data[i].classNames = data[i].classNames || [];
                    data[i].classNames.push('event-selected');
                }
                //set all events to not editable if one is currently selected
                data[i].editable = false;
            }
        }
        setEvents(data);
    }

    const getEvents = () => {
        if (dates && dates.startStr) {
            postData(`${eventUrl}?start=${dates.startStr}&end=${dates.endStr}`,
                null,
                (data) => setEventsWithClass(data.items),
                null,
                true);
        }
    }

    const resetView = (data) => {
        //updating selectedEvent will cause the useEffect to fire a getEvents
        setSelectedEvent();
        setAppointment();
        setSaving(false);
        if (data && data.errors && (data.errors.warning || data.errors.error)) setAlert(data.errors);
    }

    useEffect(() => {
        if (selectedEvent) {
            const currentEvents = JSON.parse(JSON.stringify(events));
            setEventsWithClass(currentEvents);
        } else {
            getEvents();
        }
    },
        [selectedEvent]);

    useEffect(() => {
        getEvents();
    },
        [dates]);

    const postUpdate = (appointmentToUpdate) => {
        if (appointmentToUpdate.appointmentType === 1 && appointmentToUpdate.id === 0 && newAppointment) {
            newAppointment.startTime = appointmentToUpdate.start;
            newAppointment.endTime = appointmentToUpdate.end;
            newAppointment.designerId = appointmentToUpdate.resourceId;
            postData('/api/calendar/sales/edit', { item: newAppointment }, resetView);
        } else {
            postData('/api/calendar/scheduleAppointment', { item: appointmentToUpdate }, resetView);
        }
    }

    const addOrUpdateEvent = (fcEvent) => {

        const currentEvents = JSON.parse(JSON.stringify(events));
        let appointmentToUpdate = currentEvents.find(r => r.id === parseInt(fcEvent.id));

        if (!appointmentToUpdate) {
            appointmentToUpdate = appointment;
            currentEvents.push(appointmentToUpdate);
        }

        //only allow all day event if personal time
        if (fcEvent.allDay && appointmentToUpdate.appointmentType !== 4) return;

        if (!fcEvent.resourceId) return;

        appointmentToUpdate.start = formatter.dateTimeLocalEncoded(fcEvent.start);
        appointmentToUpdate.end = formatter.dateTimeLocalEncoded(fcEvent.end);

        if (fcEvent.resourceId) {
            appointmentToUpdate.resourceId = parseInt(fcEvent.resourceId);
        }

        appointmentToUpdate.classNames = appointmentToUpdate.classNames || [];
        appointmentToUpdate.classNames.push('event-selected')

        setEvents(currentEvents);

        if (confirm) {
            confirm(appointmentToUpdate);
        } else {
            postUpdate(appointmentToUpdate);
        };
    }

    //time period selected on calendar
    const select = (selectionInfo) => {
        const event = selectionInfo;
        event.id = appointment.id;
        if (selectionInfo.resource) {
            event.resourceId = selectionInfo.resource.id;
        }
        addOrUpdateEvent(event);
    }

    const eventClick = (clickInfo) => {
        //currently working on another event, so do nothing
        if (selectedEvent) return;
        //find the clicked event in our collection of events
        //FullCalendar doesn't always return all properties with the clickInfo
        const clickedEvent = events.find(r => r.id === parseInt(clickInfo.event.id)
            && r.appointmentType === clickInfo.event.extendedProps.appointmentType);

        //if personal time is not editable, exit
        //other appointment types will show a readonly modal
        if (clickedEvent.appointmentType === 4 && !clickedEvent.editable) return;
        setSelectedEvent(clickedEvent);
    }

    const startScheduling = () => {
        setAppointment(selectedEvent);
    }

    const eventResize = (dragInfo) => addOrUpdateEvent(dragInfo.event);

    const eventDrop = (dropInfo) => {
        const event = dropInfo.event;
        if (dropInfo.newResource) {
            event.resourceId = dropInfo.newResource.id;
        }
        addOrUpdateEvent(event);
    }

    function formatEvent(eventInfo) {
        const viewType = eventInfo.view.type;
        console.log(viewType);

        const getView = () => {
            const addressLine = eventInfo.event.extendedProps && eventInfo.event.extendedProps.address &&
                `${eventInfo.event.extendedProps.address.city}, ${eventInfo.event.extendedProps.address.stateName}`;

            switch (viewType) {
                case 'customMonth':
                    return (
                        <div className="fc-event-main-frame flex-column">
                            <div className="d-flex justify-content-between">
                                <div className="text-truncate event-title">{eventInfo.event.title}</div>
                                <div className="event-time">{formatter.time(eventInfo.event.start)}</div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div className="event-address">{addressLine}</div>
                                {eventInfo.event.extendedProps && eventInfo.event.extendedProps.jobTotal > 0 &&
                                    <div className="event-time">{formatter.currency(eventInfo.event.extendedProps.jobTotal)}</div>
                                }
                            </div>
                            <div className="event-resource">{eventInfo.event.extendedProps.resourceName}</div>
                        </div>
                    );
                case 'customDay':
                case 'customWeek':
                    return (
                        <div className="fc-event-main-frame flex-column">
                            <div className="text-truncate event-title fc-sticky">{eventInfo.event.title}</div>
                            <div className="event-address">{addressLine}</div>
                            <div className="event-resource">{eventInfo.event.extendedProps.resourceName}</div>
                            {eventInfo.event.extendedProps && eventInfo.event.extendedProps.jobTotal > 0 &&
                                <div className="event-time">{formatter.currency(eventInfo.event.extendedProps.jobTotal)}</div>
                            }
                        </div>
                    );
                case 'schedulerDay':
                    return (
                        <div className="fc-event-main-frame flex-column">
                            <div className="fc-event-title fc-sticky">{eventInfo.event.title}</div>
                            <div className="event-address">{addressLine}</div>
                        </div>
                    );
            }

        };

        return getView();
    }

    const views = {
        schedulerDay: {
            buttonText: 'Scheduler',
            type: 'resourceTimeline',
            duration: { days: 1 },
            slotMinWidth: '100'

        },
        customDay: {
            type: 'timeGrid',
            buttonText: 'Day',
            duration: { days: 1 },
            eventMinHeight: '60',
            slotEventOverlap: false
        },
        customWeek: {
            type: 'timeGrid',
            buttonText: 'Week',
            duration: { days: 7 },
            eventMinHeight: '60',
            slotEventOverlap: false
        },
        customMonth: {
            type: 'dayGrid',
            buttonText: 'Month',
            duration: { weeks: 5 },
        }
    }

    const buttonText = {
        prev: '<',
        next: '>',
        customDay: 'Day',
        customWeek: 'Week',
        schedulerDay: 'Scheduler',
        customMonth: 'Month',
        today: 'Today'
    }

    return {
        events,
        formatEvent,
        setEvents,
        resources,
        setResources,
        setDates,
        select,
        selectedEvent,
        eventClick,
        resetView,
        startScheduling,
        eventResize,
        eventDrop,
        views,
        buttonText,
        postUpdate
    }
}

export default useCalendar